// extracted by mini-css-extract-plugin
export default {"container":"ImageSortModal_container__i2d+a","image":"ImageSortModal_image__PeCx0","spin":"ImageSortModal_spin__OoKNa"};